function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M7.3,5.2h35.1l-6.2,15c-0.5,1.2-1.7,2-2.9,2h-19L7.3,5.2z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 16.8,
  y: 27.5,
  className: "st1",
  width: 0.3,
  height: 0.5
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M16.1,22.2"
})), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M7.5,4.9L6.3,2.1C5.8,0.8,4.5,0,3.2,0H0v0.5h3.2c1.2,0,2.3,0.7,2.7,1.8L14,21.9c-0.8,0-1.5,0.3-2,0.9 c-0.6,0.6-0.9,1.3-0.9,2.2c0,1.7,1.4,3,3,3h21.3v-0.5H14.1c-1.4,0-2.5-1.1-2.5-2.5c0-0.7,0.3-1.3,0.8-1.8s1.1-0.8,1.8-0.8h19.2 c1.4,0,2.7-0.8,3.2-2.1L43,4.9L7.5,4.9z M36,20.1c-0.5,1.1-1.5,1.8-2.7,1.8H14.5L7.7,5.4h34.4L36,20.1z"
}));

var SvgFilledCart = function SvgFilledCart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 42.8 28",
    style: {
      enableBackground: "new 0 0 42.8 28"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFilledCart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/filled-cart.1268b6d6.svg";
export { ForwardRef as ReactComponent };